import type { LocationModel } from '@/domains/locations/types/models/LocationModel.types'
import type { CreateLocationRequest } from '@/domains/locations/types/requests/CreateLocationRequest.types'
import type {
  LocationsDestroyPayload,
  LocationsIndexPayload,
  LocationsShowPayload,
  LocationsStorePayload,
  LocationsUpdatePayload
} from '@/domains/locations/types/requests/EndpointRequest.types'
import type { UpdateLocationRequest } from '@/domains/locations/types/requests/UpdateLocationRequest.types'
import type { LocationIndexResponse } from '@/domains/locations/types/responses/LocationIndexResponse.types'

import { twineServiceClient } from '@/services/api'
import { relativeZiggyRoute } from '@/utils/url-util/urlUtil'

const callLocations = () => {
  const index = (payload: LocationsIndexPayload = {}) => {
    return twineServiceClient.get<LocationIndexResponse>({
      endpoint: relativeZiggyRoute('admin.inventory.locations.index'),
      queryParams: payload.queryParams,
      preventConcurrent: payload.preventConcurrent,
      token: payload.token
    })
  }

  const show = (payload: LocationsShowPayload) => {
    return twineServiceClient.get<LocationModel>({
      endpoint: relativeZiggyRoute('admin.inventory.locations.show', { location: payload.id }),
      preventConcurrent: payload.preventConcurrent,
      token: payload.token
    })
  }

  const store = (payload: LocationsStorePayload) => {
    return twineServiceClient.post<LocationModel, CreateLocationRequest>({
      endpoint: relativeZiggyRoute('admin.inventory.locations.store'),
      body: payload.body,
      preventConcurrent: payload.preventConcurrent,
      token: payload.token
    })
  }

  const update = (payload: LocationsUpdatePayload) => {
    return twineServiceClient.put<LocationModel, UpdateLocationRequest>({
      endpoint: relativeZiggyRoute('admin.inventory.locations.update', { location: payload.id }),
      body: payload.body,
      preventConcurrent: payload.preventConcurrent,
      token: payload.token
    })
  }

  const destroy = (payload: LocationsDestroyPayload) => {
    return twineServiceClient.delete<void>({
      endpoint: relativeZiggyRoute('admin.inventory.locations.delete', { location: payload.id }),
      preventConcurrent: payload.preventConcurrent,
      token: payload.token
    })
  }

  return { index, show, store, update, destroy }
}

export { callLocations }
